export default __webpack_public_path__ + "static/media/x.ad8613f9.svg";